var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-rma-request-header"},[_c('h2',{staticClass:"order-rma-request-header__id"},[_vm._v("Order #"+_vm._s(_vm.id))]),_c('span',{staticClass:"order-rma-request-header__date"},[_vm._v("Created at "+_vm._s(_vm._f("date")(_vm.createdDate)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }